import { useState, useEffect } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function EditAdult(props) {
    const { adultToEdit, updateAdult } = props;
    const [open, setOpen] = useState(false);
    const [adult, setAdult] = useState({
        id: '',
        dateAdded: new Date(),
        adultName: '',
        adultSurname: '',
        adultEmail: '',
        adultPhone: '',
        adultNationality: '',
        allergies: '',
        notes: '',
    });

    useEffect(() => {
        if (adultToEdit) {
            const safeDate = (dateString) => {
                const date = new Date(dateString);
                return date instanceof Date && !isNaN(date) ? date : new Date(); // Default to current date if invalid
              };
            setAdult({
                id: adultToEdit.id,
                dateAdded: safeDate(adultToEdit.dateAdded),
                adultName: adultToEdit.adultName,
                adultSurname: adultToEdit.adultSurname,
                adultEmail: adultToEdit.adultEmail,
                adultPhone: adultToEdit.adultPhone,
                adultNationality: adultToEdit.adultNationality,
                allergies: adultToEdit.allergies,
                notes: adultToEdit.notes
            });
        }
    }, [adultToEdit]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        console.log(adult);
        updateAdult(adult, adult.id); // This method should handle the PUT request.
        handleClose();
    };

    const handleDateChange = (date, name) => {
        setAdult(prevAdult => ({
          ...prevAdult,
          [name]: date
        }));
      };

    const handleChange = (event) => {
        const { name, value } = event.target;
        setAdult((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    return (
        <div>
            <IconButton onClick={handleClickOpen} color="primary">
                <EditIcon />
            </IconButton>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Edit Adult</DialogTitle>
                <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={2} mt={1}>
                        <DatePicker
                        label="Date Added"
                        value={adult.dateAdded}
                        onChange={(date) => handleDateChange(date, 'dateAdded')}
                        renderInput={(params) => (
                            <TextField
                            {...params}
                            fullWidth
                            sx={{ mb: 0, mt: 0 }}
                            />
                            )}
                        /><TextField 
                            fullWidth 
                            label="Name" 
                            name="adultName"
                            variant="standard" 
                            value={adult.adultName} 
                            onChange={handleChange}
                        />
                        <TextField 
                            fullWidth 
                            label="Surname" 
                            name="adultSurname" 
                            variant="standard" 
                            value={adult.adultSurname} 
                            onChange={handleChange}
                        />
                        <TextField 
                            fullWidth 
                            label="Email" 
                            name="adultEmail" 
                            variant="standard" 
                            value={adult.adultEmail} 
                            onChange={handleChange}
                        />
                        <TextField 
                            fullWidth 
                            label="Phone" 
                            name="adultPhone" 
                            variant="standard" 
                            value={adult.adultPhone} 
                            onChange={handleChange}
                        />
                        <TextField 
                            fullWidth 
                            label="Nationality" 
                            name="adultNationality" 
                            variant="standard" 
                            value={adult.adultNationality} 
                            onChange={handleChange}
                        />
                        <TextField 
                            fullWidth 
                            label="Allergies" 
                            name="allergies" 
                            variant="standard" 
                            value={adult.allergies} 
                            onChange={handleChange}
                        />
                        <TextField 
                            fullWidth 
                            label="Notes" 
                            name="notes" 
                            variant="standard" 
                            value={adult.notes} 
                            onChange={handleChange}
                        />
                    </Stack>
                </LocalizationProvider>
                </DialogContent>    
            
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleSave}>Save</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default EditAdult;
